import script from "./PUR02_017MainGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR02_017MainGrid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__